import { NoSymbolIcon } from './icons'

// A sold-out row stays where it is, dimmed, with this band where its promo chip was:
// removing the row would reflow the whole board every time an item flips mid-service.
export function SoldOutBand({ size = 20 }: { size?: number }) {
  return (
    <span
      className="inline-flex items-center space-x-[8px] px-[14px] py-[6px] rounded-[8px] bg-brand-ink text-white font-secondary font-bold uppercase tracking-[0.06em]"
      style={{ fontSize: size, lineHeight: 1 }}
    >
      <NoSymbolIcon size={size + 2} />
      <span>Sold out</span>
    </span>
  )
}
